import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseCarFilled: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 13V12.8284C22.5 11.9002 22.1312 11.0099 21.4749 10.3536L21.2784 10.157L21.1156 9.75H22.5C22.9142 9.75 23.25 9.41421 23.25 9C23.25 8.58579 22.9142 8.25 22.5 8.25H20.5156L19.8956 6.70013C19.3641 5.37133 18.0771 4.5 16.6459 4.5H7.35407C5.9229 4.5 4.63592 5.37133 4.1044 6.70013L3.48445 8.25H1.5C1.08579 8.25 0.75 8.58579 0.75 9C0.75 9.41421 1.08579 9.75 1.5 9.75H2.88445L2.72163 10.157L2.52513 10.3536C1.86875 11.0099 1.5 11.9002 1.5 12.8284V13V16V19C1.5 19.8284 2.17157 20.5 3 20.5H5C5.82843 20.5 6.5 19.8284 6.5 19V18H17.5V19C17.5 19.8284 18.1716 20.5 19 20.5H21C21.8284 20.5 22.5 19.8284 22.5 19V16V13ZM19.8 10.5H4.2L5.49711 7.25722C5.80084 6.4979 6.53626 6 7.35407 6H16.6459C17.4637 6 18.1992 6.4979 18.5029 7.25722L19.8 10.5ZM5 14.75C5.69036 14.75 6.25 14.1904 6.25 13.5C6.25 12.8096 5.69036 12.25 5 12.25C4.30964 12.25 3.75 12.8096 3.75 13.5C3.75 14.1904 4.30964 14.75 5 14.75ZM9 14.25C8.58579 14.25 8.25 14.5858 8.25 15C8.25 15.4142 8.58579 15.75 9 15.75H15C15.4142 15.75 15.75 15.4142 15.75 15C15.75 14.5858 15.4142 14.25 15 14.25H9ZM20.75 13.5C20.75 14.1904 20.1904 14.75 19.5 14.75C18.8096 14.75 18.25 14.1904 18.25 13.5C18.25 12.8096 18.8096 12.25 19.5 12.25C20.1904 12.25 20.75 12.8096 20.75 13.5Z"
        fill={color}
      />
    </svg>
  );
};
